module.exports = __webpack_public_path__ + "assets/img/app-logo.d2563c4f.svg";